module.exports = __webpack_public_path__ + "img/house-projects.a46c252b.jpg";